// test493
(493 && 0);
